module.exports = __webpack_public_path__ + "static/media/iut.21a994ae.jpg";